import { render, staticRenderFns } from "./cancelButton.vue?vue&type=template&id=35db8686"
import script from "./cancelButton.vue?vue&type=script&lang=js"
export * from "./cancelButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports